import React, { useEffect, useState, useCallback, useRef } from "react";
import {
    useLoadCandidateAppsQuery,
    useLoadAppRuningTasksQuery,
    useLoadAppFormLibraryQuery
} from "../../store/candidateApiSlice";
import { getCurrentUser } from "../../store/auth";
import { useDispatch, useSelector } from "react-redux";
import { loadAppFormLibrary, loadAppRuningTasks, loadCandidateApps } from "../../store/candidate";
import { getFieldData } from "../../../Services/appService";
import Moment from "react-moment";
import { useNavigate } from "react-router-dom";
import { setCurrentPageTitle, setCurrentRoute } from "../../store/layoutUI";
import { getWorkflowTask, loadWorkflowTask, workflowTaskReceived } from "../../store/WorkflowEngine";
import { addFormLibrary, formLibraryAdded, getAppFormLibraryAddedStatus } from "../../store/forms";
import { loadToolsCount } from "../../store/tools";

const ONBOARDING_PAGE_STYLES = {
    shell: {
        fontFamily: '"Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        marginTop: "10px",
        width: "100%"
    },
    card: {
        borderRadius: "20px",
        border: "1px solid rgba(226, 232, 240, 0.95)",
        backgroundColor: "#ffffff",
        boxShadow: "0 10px 30px rgba(15, 23, 42, 0.05)",
        overflow: "hidden"
    },
    cardHeader: {
        padding: "18px 22px",
        borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
        background: "linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%)"
    },
    headerRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "16px",
        flexWrap: "wrap"
    },
    headerCopy: {
        minWidth: "240px",
        flex: "1 1 420px"
    },
    headerActions: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end"
    },
    cardTitle: {
        fontSize: "18px",
        fontWeight: 800,
        color: "#0f172a",
        lineHeight: 1.25,
        margin: 0
    },
    titleRow: {
        display: "flex",
        alignItems: "center",
        gap: "12px"
    },
    titleIcon: {
        width: "36px",
        height: "36px",
        borderRadius: "10px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#ffffff",
        color: "#2563eb",
        fontSize: "15px",
        border: "1px solid rgba(191, 219, 254, 0.9)",
        boxShadow: "0 4px 12px rgba(37, 99, 235, 0.06)",
        flexShrink: 0
    },
    titleText: {
        display: "flex",
        flexDirection: "column",
        gap: "2px",
        minWidth: 0
    },
    cardText: {
        fontSize: "13px",
        lineHeight: 1.45,
        color: "#64748b",
        margin: 0
    },
    cardBody: {
        padding: "0"
    },
    refreshButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        borderRadius: "8px",
        border: "1px solid rgba(203, 213, 225, 0.9)",
        background: "#ffffff",
        color: "#334155",
        padding: "6px 14px",
        fontSize: "12px",
        fontWeight: 700,
        cursor: "pointer",
        transition: "all 0.2s ease",
        boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)"
    },
    tableWrap: {
        overflowX: "auto",
        backgroundColor: "#ffffff"
    },
    table: {
        width: "100%",
        marginBottom: 0,
        borderCollapse: "separate",
        borderSpacing: 0
    },
    tableHeadCell: {
        borderTop: "none",
        fontSize: "11px",
        fontWeight: 800,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: "#64748b",
        background: "#f8fafc",
        borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
        padding: "14px 16px"
    },
    idValue: {
        fontSize: "14px",
        fontWeight: 800,
        color: "#0f172a",
        display: "flex",
        alignItems: "center",
        gap: "8px"
    },
    idIcon: {
        color: "#2563eb",
        fontSize: "12px"
    },
    actionStack: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        flexWrap: "wrap"
    },
    dateContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "2px"
    },
    datePrimary: {
        fontSize: "14px",
        fontWeight: 700,
        color: "#0f172a"
    },
    dateSecondary: {
        fontSize: "12px",
        color: "#64748b"
    },
    primaryAction: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        borderRadius: "8px",
        border: "1px solid rgba(191, 219, 254, 0.95)",
        background: "#eff6ff",
        color: "#1d4ed8",
        padding: "6px 14px",
        fontSize: "12px",
        fontWeight: 700,
        cursor: "pointer",
        transition: "all 0.2s ease",
        textDecoration: "none"
    },
    secondaryAction: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        borderRadius: "8px",
        border: "1px solid rgba(203, 213, 225, 0.9)",
        background: "#ffffff",
        color: "#334155",
        padding: "6px 14px",
        fontSize: "12px",
        fontWeight: 700,
        cursor: "pointer",
        transition: "all 0.2s ease"
    },
    startButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "8px",
        border: "none",
        background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
        color: "#ffffff",
        padding: "9px 18px",
        fontSize: "13px",
        fontWeight: 700,
        boxShadow: "0 4px 14px rgba(37, 99, 235, 0.25)",
        cursor: "pointer",
        transition: "all 0.2s ease"
    },
    loadingCell: {
        padding: "40px 20px",
        textAlign: "center",
        background: "#ffffff"
    },
    loadingContent: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "12px"
    },
    loadingSpinnerWrap: {
        width: "40px",
        height: "40px",
        borderRadius: "10px",
        background: "#eff6ff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#2563eb",
        fontSize: "16px"
    },
    loadingText: {
        fontSize: "13px",
        fontWeight: 700,
        color: "#64748b",
        margin: 0
    }
};

const REQUIRED_LIBRARY_FORMS = [
    {
        formId: 47,
        formName: "ACH Payment Information",
        remarks:
            "This information is captured for making Payments to your company by ACH",
        formType: "ACH Information",
    },
    {
        formId: 22,
        formName: "Insurance Details",
        remarks:
            "Upload your company's insurance certificate(s) as per the contract requirements",
        formType: "Insurance Information",
    },
];

export default function Onboarding() {
    const usrType = localStorage.getItem("userType");

    const route = [
        { name: "Task Management", url: "" },
        { name: "Onboarding Steps", url: "" },
    ];
    const route1 = [
        { name: "Contract Management", url: "" },
        { name: "Enrollment Steps", url: "" },
    ];

    let appType = "Onboarding Form";
    if (usrType === "candidate")
        appType = "Onboarding Form";

    const [appTasklist, setAppTasklist] = useState([]);
    const [entityType, setEntityType] = useState("");
    const [appSubmitStatus, setAppSubmitStatus] = useState(false);
    const [startBtnProccess, setStartBtnProccess] = useState(false);
    const [addFormlibraryStatus, setAddFormlibraryStatus] = useState(false);
    const [wfId, setWfId] = useState(null);
    const [wfTask, setWfTask] = useState(null);
    const processedLibraryKeysRef = useRef(new Set());
    const toolsCountRefreshTimeoutRef = useRef(null);

    const workflowTaskSelector = useSelector(getWorkflowTask);
    const appFormLibraryAddedStatusSelector = useSelector(getAppFormLibraryAddedStatus);

    const dispatch = useDispatch();
    const currentUser = getCurrentUser();
    const navigate = useNavigate();

    let usrId = currentUser?.id;
    if (currentUser?.linkUser) usrId = currentUser.linkUser;

    const { data: candidateAppsSelector = [], isLoading: isAppsLoading } = useLoadCandidateAppsQuery(usrId, { skip: !usrId });
    const { data: appTasksSelector = [], isLoading: isTasksLoading } = useLoadAppRuningTasksQuery(
        { wfId, userId: usrId },
        { skip: !wfId || !usrId }
    );
    const { data: appFormLibrarySelector = [], isSuccess: isAppFormLibraryLoaded } = useLoadAppFormLibraryQuery(
        { wfId, userId: usrId },
        { skip: !wfId || !usrId }
    );

    const loadingStatus = isAppsLoading || isTasksLoading;

    useEffect(() => {
        dispatch(setCurrentPageTitle(`STEP-1 : ${appType}`));
        dispatch(setCurrentRoute(usrType === "candidate" ? route : route1));
    }, [dispatch, appType, usrType, route, route1]);

    useEffect(() => {
        if (candidateAppsSelector.length > 0) {
            const mainWorkflow = candidateAppsSelector.filter(x => x.workflowType === 1);
            if (mainWorkflow.length > 0) {
                const wf = mainWorkflow[0];
                setWfId(wf.oldWorkflowId);
            }
        }
    }, [candidateAppsSelector]);

    useEffect(() => {
        if (appTasksSelector.length > 0) {
            const filterTasks = appTasksSelector.filter(x => x.taskType === 1 && x.wiid > 0 && x.taskName === "Onboarding/Enrollment");
            let firstAppTasks = [];
            if (filterTasks.length > 0) {
                firstAppTasks = [filterTasks[0]];
                setAppTasklist(firstAppTasks);
                setAppSubmitStatus(firstAppTasks[0].appSubmit);
                const entType = getFieldData(
                    firstAppTasks[0].stateData,
                    "candidateonboardingform",
                    "CandidateEntity"
                );
                setEntityType(entType);
                const tsk = filterTasks[0];
                setWfTask({
                    ciid: tsk.ciid,
                    wiid: tsk.wiid,
                    iiid: tsk.iiid,
                    applicantId: tsk.performerId,
                    performerId: 1,
                });
                if (wfId && entType !== "C2C Basis" && !addFormlibraryStatus) {
                    setAddFormlibraryStatus(true);
                }
            }
        }
    }, [appTasksSelector, wfId, addFormlibraryStatus]);

    const handleCurrentTask = (wiid) => {
        setStartBtnProccess(true);
        dispatch(loadWorkflowTask(wiid));
    };

    useEffect(() => {
        if (workflowTaskSelector && startBtnProccess) {
            setStartBtnProccess(false);
            if (workflowTaskSelector.formType === "CF")
                navigate("/" + workflowTaskSelector.formName, { state: { workflowTask: workflowTaskSelector } });
            else
                navigate("/DynamicForm", { state: { workflowTask: workflowTaskSelector } });

            dispatch(workflowTaskReceived(""));
        }
    }, [workflowTaskSelector, startBtnProccess, navigate, dispatch]);

    const handleViewAppSummary = (item, type) => {
        navigate("/ApplicationSummary", { state: { task: item, viewType: type } });
    };

    const addReqFormLibrary = useCallback((currentTask, frmObj) => {
        const frmData = new FormData();
        frmData.append("workflowTask", JSON.stringify(currentTask));
        frmData.append("formId", frmObj.formId);
        frmData.append("formName", frmObj.formName);
        frmData.append("remarks", frmObj.remarks);
        frmData.append("id", "");
        frmData.append("formType", frmObj.formType);
        frmData.append("status", "1");
        dispatch(addFormLibrary(frmData));
    }, [dispatch]);

    useEffect(() => {
        if (
            !isAppFormLibraryLoaded ||
            !wfTask ||
            !wfId ||
            !usrId ||
            entityType === "C2C Basis" ||
            !addFormlibraryStatus
        ) {
            return;
        }

        const libraryKey = `${wfId}:${usrId}:${wfTask.wiid}`;
        if (processedLibraryKeysRef.current.has(libraryKey)) return;

        processedLibraryKeysRef.current.add(libraryKey);

        REQUIRED_LIBRARY_FORMS.forEach((form) => {
            const hasForm = appFormLibrarySelector.some((item) => item.formType === form.formType);
            if (!hasForm) addReqFormLibrary(wfTask, form);
        });
    }, [
        appFormLibrarySelector,
        isAppFormLibraryLoaded,
        wfTask,
        wfId,
        usrId,
        entityType,
        addFormlibraryStatus,
        addReqFormLibrary,
    ]);

    useEffect(() => {
        if (appFormLibraryAddedStatusSelector) {
            if (toolsCountRefreshTimeoutRef.current) {
                clearTimeout(toolsCountRefreshTimeoutRef.current);
            }

            toolsCountRefreshTimeoutRef.current = setTimeout(() => {
                if (wfId && usrId) {
                    dispatch(loadAppFormLibrary(wfId, usrId, { subscribe: false, forceRefetch: true }));
                    dispatch(loadToolsCount(usrId));
                }
                toolsCountRefreshTimeoutRef.current = null;
            }, 300);

            dispatch(formLibraryAdded(false));
        }
    }, [appFormLibraryAddedStatusSelector, wfId, usrId, dispatch]);

    useEffect(() => () => {
        if (toolsCountRefreshTimeoutRef.current) {
            clearTimeout(toolsCountRefreshTimeoutRef.current);
        }
    }, []);

    const handleRefresh = () => {
        let usrId = currentUser.id;
        if (currentUser.linkUser) usrId = currentUser.linkUser;
        if (usrId > 0) dispatch(loadCandidateApps(usrId, { subscribe: false, forceRefetch: true }));
        if (wfId && usrId > 0) {
            dispatch(loadAppRuningTasks(wfId, usrId, { subscribe: false, forceRefetch: true }));
            dispatch(loadAppFormLibrary(wfId, usrId, { subscribe: false, forceRefetch: true }));
        }
    };

    return (
        <React.Fragment>
            <style>{`
                .onboarding-btn-hover:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15) !important;
                }
                .onboarding-start-btn:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 20px rgba(37, 99, 235, 0.35) !important;
                }
                .onboarding-table tbody tr:hover td {
                    background-color: #f8fbff !important;
                }
            `}</style>

            <div style={ONBOARDING_PAGE_STYLES.shell}>
                <div style={ONBOARDING_PAGE_STYLES.card}>
                    <div style={ONBOARDING_PAGE_STYLES.cardHeader}>
                        <div style={ONBOARDING_PAGE_STYLES.headerRow}>
                            <div style={ONBOARDING_PAGE_STYLES.headerCopy}>
                                <div style={ONBOARDING_PAGE_STYLES.titleRow}>
                                    <span style={ONBOARDING_PAGE_STYLES.titleIcon}>
                                        <i className="fa fa-file-text-o" aria-hidden="true"></i>
                                    </span>
                                    <div style={ONBOARDING_PAGE_STYLES.titleText}>
                                        <h1 style={ONBOARDING_PAGE_STYLES.cardTitle}>Onboarding Form</h1>
                                        {!appSubmitStatus && (
                                            <p style={ONBOARDING_PAGE_STYLES.cardText}>
                                                Click on START button below to complete your {appType}
                                            </p>
                                        )}
                                        {appSubmitStatus && (
                                            <p style={ONBOARDING_PAGE_STYLES.cardText}>
                                                Review the submitted onboarding record and open it for viewing or updates.
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div style={ONBOARDING_PAGE_STYLES.headerActions}>
                                <button
                                    type="button"
                                    className="onboarding-btn-hover"
                                    style={ONBOARDING_PAGE_STYLES.refreshButton}
                                    onClick={handleRefresh}
                                >
                                    <i className="fa fa-refresh" aria-hidden="true"></i>
                                    Refresh
                                </button>
                            </div>
                        </div>
                    </div>

                    <div style={ONBOARDING_PAGE_STYLES.cardBody}>
                        <div style={ONBOARDING_PAGE_STYLES.tableWrap}>
                            <table className="onboarding-table" style={ONBOARDING_PAGE_STYLES.table}>
                                <thead>
                                    <tr>
                                        <th style={ONBOARDING_PAGE_STYLES.tableHeadCell}>ID</th>
                                        {appSubmitStatus && (
                                            <>
                                                <th style={ONBOARDING_PAGE_STYLES.tableHeadCell}>Date & Time Submitted</th>
                                                <th style={ONBOARDING_PAGE_STYLES.tableHeadCell}>{appType}</th>
                                            </>
                                        )}
                                        {!appSubmitStatus && (
                                            <th style={ONBOARDING_PAGE_STYLES.tableHeadCell}>Action</th>
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {!loadingStatus ? (
                                        appTasklist.map((item) => (
                                            <tr key={item.wiid}>
                                                <td style={{ padding: "14px 16px", borderBottom: "1px solid rgba(241, 245, 249, 1)" }}>
                                                    <div style={ONBOARDING_PAGE_STYLES.idValue}>
                                                        <i className="fa fa-hashtag" style={ONBOARDING_PAGE_STYLES.idIcon} aria-hidden="true"></i>
                                                        {item.ciid}
                                                    </div>
                                                </td>

                                                {appSubmitStatus && (
                                                    <>
                                                        <td style={{ padding: "14px 16px", borderBottom: "1px solid rgba(241, 245, 249, 1)" }}>
                                                            <div style={ONBOARDING_PAGE_STYLES.dateContainer}>
                                                                <div style={ONBOARDING_PAGE_STYLES.datePrimary}>
                                                                    <Moment format="MMM Do, YYYY">{item.startDateTime}</Moment>
                                                                </div>
                                                                <div style={ONBOARDING_PAGE_STYLES.dateSecondary}>
                                                                    <Moment format="h:mm a">{item.startDateTime}</Moment>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td style={{ padding: "14px 16px", borderBottom: "1px solid rgba(241, 245, 249, 1)" }}>
                                                            <div style={ONBOARDING_PAGE_STYLES.actionStack}>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => handleViewAppSummary(item, "view")}
                                                                    className="onboarding-btn-hover"
                                                                    style={ONBOARDING_PAGE_STYLES.primaryAction}
                                                                >
                                                                    <i className="fa fa-eye" aria-hidden="true"></i>
                                                                    View Form
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => handleViewAppSummary(item, "editnId")}
                                                                    className="onboarding-btn-hover"
                                                                    style={ONBOARDING_PAGE_STYLES.secondaryAction}
                                                                >
                                                                    <i className="fa fa-pencil" aria-hidden="true"></i>
                                                                    Edit Details
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </>
                                                )}

                                                {!appSubmitStatus && (
                                                    <td style={{ padding: "14px 16px", borderBottom: "1px solid rgba(241, 245, 249, 1)" }}>
                                                        <button
                                                            type="button"
                                                            onClick={() => handleCurrentTask(item.wiid)}
                                                            disabled={item.performerId !== parseInt(currentUser?.id) || startBtnProccess}
                                                            className="onboarding-start-btn"
                                                            style={ONBOARDING_PAGE_STYLES.startButton}
                                                        >
                                                            {startBtnProccess ? (
                                                                <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
                                                            ) : (
                                                                <i className="fa fa-play-circle" aria-hidden="true"></i>
                                                            )}
                                                            {startBtnProccess ? "Processing..." : `Start ${item.taskName}`}
                                                        </button>
                                                    </td>
                                                )}
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={appSubmitStatus ? 3 : 2} style={ONBOARDING_PAGE_STYLES.loadingCell}>
                                                <div style={ONBOARDING_PAGE_STYLES.loadingContent}>
                                                    <div style={ONBOARDING_PAGE_STYLES.loadingSpinnerWrap}>
                                                        <i className="fa fa-circle-o-notch fa-spin"></i>
                                                    </div>
                                                    <div style={ONBOARDING_PAGE_STYLES.loadingText}>Fetching onboarding data...</div>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
